module.exports = __webpack_public_path__ + "img/t4-c5.29608652.png";